<template>
  <div class="login-view-div" id="auth-container"></div>
</template>

<script>
  import { firebaseAuth, firebaseApp } from "@/firebase";
  import * as firebaseui from "firebaseui";
  import "firebaseui/dist/firebaseui.css";

  export default {
    name: "LoginView",
    mounted() {
      let ui = new firebaseui.auth.AuthUI(firebaseAuth);
      let uiConfig = {
        callbacks: {
          uiShown: function() {
            document.getElementsByClassName('firebaseui-phone-tos')[0].innerHTML = 'By tapping Verify, an SMS will be sent. Data rates may apply.';
          }
        },
        signInSuccessUrl: "/",
        signInOptions: [
          {
            provider: firebaseApp.auth.PhoneAuthProvider.PROVIDER_ID,
            defaultCountry: 'EE'
          },
          {
            provider: firebaseApp.auth.EmailAuthProvider.PROVIDER_ID
          }
        ]
      };
      ui.start("#auth-container", uiConfig);
    }
  }
</script>

<style scoped>
  .login-view-div {
    margin-top: 100px;
  }
</style>
